// Strip hyphens only (e.g. "12345-6789-01" -> "12345678901") — matching the
// backend's own normalization exactly (fulfillByRxNumberService.ts's
// normaliseNdc), since it's the authoritative comparison at commit time.
// Anything more lenient (stripping all non-digit characters, say) could see
// two NDCs as "matching" here while the backend's stricter check rejects
// them, or vice versa.
const normalizeNdc = (v) =>
  String(v ?? '')
    .replace(/-/g, '')
    .trim();

const ndcsMatch = (a, b) => {
  const na = normalizeNdc(a);
  const nb = normalizeNdc(b);
  return na.length > 0 && na === nb;
};

export default ndcsMatch;
